import React from 'react'

import {Routes} from '@/src/config/routes'
import {isProductViewModelWithVariants} from '@/src/entities/product/helpers/validators'
import {ProductListItemViewModel} from '@/src/entities/product/model'
import {ProductAttributeValuesContainer} from '@/src/features/catalog/product-list/product-attribute-values-container'
import {ProductBuyButtonContainer} from '@/src/features/catalog/product-list/product-buy-button-container'
import saleIcon from '@/src/shared/assets/media/icon-sale.svg'

import {ProductImageLazy} from './product-image-lazy'
import * as UI from './product-list-item.styled'
import {ProductPriceContainer} from '@/src/features/catalog/product-list/product-price-container'
import {ProductAttributesModalContainer} from '@/src/features/catalog/product-list/product-attributes-model-container'
import {toJS} from 'mobx'

interface IProps {
  badges?: React.ReactNode
  actionsMobile?: React.ReactNode
  productListItemVM: ProductListItemViewModel
}

export const ProductListItem = ({badges, actionsMobile, productListItemVM}: IProps) => {
  return (
    <UI.ProductListItem
      className="any-offer-id"
      data-testid="product"
      data-any-offer-id={
        (isProductViewModelWithVariants(productListItemVM) &&
          productListItemVM.variants.variant?.id) ||
        productListItemVM.product.id
      }>
      {(productListItemVM.price?.discount_percent ?? 0) > 0 && (
        <UI.SaleInfo $iconSrc={saleIcon.src}>
          {productListItemVM.price?.discount_percent}%
        </UI.SaleInfo>
      )}

      <UI.Badges>{badges}</UI.Badges>

      <UI.ProductListItemInner>
        <UI.ProductLink
          href={Routes.catalog.product.page(
            productListItemVM.product.code,
            productListItemVM.product.type,
          )}
          asChild>
          <UI.NameWrapper>
            <UI.ProductImage>
              <ProductImageLazy />
            </UI.ProductImage>
            <UI.ProductName data-testid="product-name" title={productListItemVM.product.name}>
              {productListItemVM.product.name}
            </UI.ProductName>
          </UI.NameWrapper>
        </UI.ProductLink>

        <UI.ProductAbsolutable>
          {/*{isProductViewModelWithVariants(productListItemVM) && productHasManyVariants(productListItemVM.product) && (*/}
          {isProductViewModelWithVariants(productListItemVM) && (
            <UI.ProductProperties>
              {productListItemVM.availableAttributes.map(attribute => (
                <UI.ProductPropertyContainer
                  key={`property-${productListItemVM.product.id}-${attribute.code}`}>
                  <UI.ProductPropertyName>{attribute.name}</UI.ProductPropertyName>
                  <UI.ProductPropertyValue>
                    <ProductAttributeValuesContainer attribute={toJS(attribute)} />
                  </UI.ProductPropertyValue>
                </UI.ProductPropertyContainer>
              ))}
            </UI.ProductProperties>
          )}

          <UI.ProductFooter>
            <ProductPriceContainer />
            <UI.ProductActions>
              <ProductBuyButtonContainer />
              <UI.MobileActions>{actionsMobile}</UI.MobileActions>
            </UI.ProductActions>
          </UI.ProductFooter>
        </UI.ProductAbsolutable>

        <ProductAttributesModalContainer />
      </UI.ProductListItemInner>
    </UI.ProductListItem>
  )
}
